import React from 'react';

const StreamLinks = ({ links }) => {
  if (!links || links.length === 0) {
    return <p>No stream links available for this match.</p>;
  }

  return (
    <div className="stream-links">
      {links.map((link, index) => {
        // Determine the platform from URL
        let platform = 'Stream';
        let icon = '📺';
        
        if (link.includes('twitch.tv')) {
          platform = 'Twitch';
          icon = '🟣';
        } else if (link.includes('youtube.com')) {
          platform = 'YouTube';
          icon = '🔴';
        }
        
        return (
          <a 
            key={index} 
            href={link} 
            className="stream-link" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <span className="stream-icon">{icon}</span>
            <span>Watch on {platform}</span>
          </a>
        );
      })}
    </div>
  );
};

export default StreamLinks;
